import NotFooterLayout from "layouts/NotFooterLayout";
import UpdateCampaign from "components/Campaign/UpdateCampaign";
import { useParams } from "react-router-dom";

function UpdateCampaignPage() {
  const { id } = useParams<{ id: string }>();
  return (
    <>
      <NotFooterLayout namePage="แก้ไขข่าวสาร / โปรโมชั่น"  >
        <div className="layout-content">
          <UpdateCampaign id={id ?? ""}  />
        </div>
      </NotFooterLayout>
    </>
  );
}

export default UpdateCampaignPage;
